import { createAction } from "@reduxjs/toolkit";
import { appReducer } from "./rootReducer";

type AppState = ReturnType<typeof appReducer>;

export type InvalidateField = "isListFetched" | "isListGamesFetched";
type InvalidateList = {
  [K in InvalidateField]: {
    [P in K]: boolean;
  }
}[InvalidateField];

export type ListSliceName = {
  [K in keyof AppState]:
    AppState[K] extends InvalidateList ? K : never;
}[keyof AppState];

export type InvalidateListPayload = {
  sliceName: ListSliceName,
  field?: InvalidateField,
}

export const invalidateList = createAction<InvalidateListPayload>('app/invalidateList',);